import fp from 'lodash/fp'
import { createAction } from 'redux-actions'
import uuid from 'uuid'
import { assignLeft } from '../util'

const namespace = 'matches.flights'

export const types = {
  ADD: 'matches/flights/ADD',
  MERGE: 'matches/flights/MERGE',
  CLEAR: 'matches/flights/CLEAR'
}

export const actions = {
  add: createAction(types.ADD),
  merge: createAction(types.MERGE),
  clear: createAction(types.CLEAR)
}

function createSelectors () {
  const getFlights = fp.get(`${namespace}.items`)
  const getFlightFromGameId = (gameId) => fp.flow(
    getFlights,
    fp.find(f => fp.includes(gameId, f.gameIds))
  )

  return {
    getFlights,
    getFlightFromGameId
  }
}

export const selectors = createSelectors()

export const initialState = {
  // {
  //   "01876b96-d0f8-436b-a851-31ffc87f29f5": {
  //     flightId: "01876b96-d0f8-436b-a851-31ffc87f29f5",
  //     gameIds: ['b26be-2b4ffe5-a173-447d-53ebfa6287a3']
  //   }
  // }
  items: {}
}

const invalidAdd = fp.flow(
  fp.at(['gameIds']),
  fp.values,
  fp.some(fp.isNil)
)

export default function reducer (state = initialState, { payload, type } = {}) {
  switch (type) {
    case types.ADD:
      if (invalidAdd(payload)) {
        console.error('Invalid payload in \'flights/ADD\'')
        return state
      }
      return fp.set(`items.${payload.flightId || uuid.v4()}`, payload, state)

    case types.MERGE:
      return fp.update(
        'items',
        assignLeft(fp.keyBy('flightId', fp.get('flights', payload)))
      )(state)

    case types.CLEAR:
      return initialState

    default:
      return state
  }
}
